import Http from "./base-http";

class Alert extends Http {
  deleteAlert(id) {
    return this.destroy(id);
  }
  addAlert(variables) {
    return this.create(variables);
  }
}
const alertObj = new Alert({
  modelUrlPrefix : "alert"
});

export default alertObj;